import React, { useEffect, useRef, useState } from "react";
import SocialPage from "./SocialPage";
import Button from "./button";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../../hooks/routes/url-constant";
import Tooltip from "@mui/material/Tooltip";
import {
  AAJADI_IMG_1,
  DISABILIT_ICON,
  G2INDIA_IMG_1,
  GOVT_IMG_1,
  HOMEICON_IMG,
  ICON_IMG,
  PMBI_IMAGE_1,
  PRIYOJNA_IMG_1,
  PROFILEICON_IMG,
  SEARCHICON_IMG,
  SWACHH_BHARAT_IMG,
  USERICON_IMG,
} from "../../utils/app-image-contant";
import i18next from "i18next";
import { useTranslation } from "react-i18next";
import GlobalSearch from "../../pages/WebsitePages/Components/Common/globalSearch";
import { getAllKendra, getAllKendraCount, getKendraVisiterCount } from "../../hooks/services/api-services";
import { toastEmitter } from "../../utils/utilities";
import { API_RESPONSE } from "../../utils/app-constants";
import { setVisitedUserReducer } from "../../hooks/redux/slice/visited-user";
import { useDispatch } from "react-redux";
import { clearAccessTokenReducer } from "../../hooks/redux/slice/access-token";
import { clearLoggedUserReducer } from "../../hooks/redux/slice/logged-user";

const Header = () => {
  const [isAccessabilityDiv, setIIsAccessabilityDiv] = useState(false);
  const [isSearch, setIsSerach] = useState(false);
  const [isChildDropdownOpen, setChildDropdownOpen] = useState(false);
  const parentDropdownRef = useRef(null);
  const [kendraCount, setKendraCount] = useState();
  const [showChildDropdown, setShowChildDropdown] = useState(false);
  const [language, setLanguage] = useState("en");
  const [incCount, setIncCount] = useState(0);
  const [disCount, setDisCount] = useState(0);
  const [disbtn, setdisbtn] = useState(true);
  const [bgColor, setBgColor] = useState(localStorage.getItem("bgColor") || "");
  const [color, setColor] = useState(localStorage.getItem("color") || "");
  const [payload, setPayload] = useState({
    "pageIndex": 0,
    "pageSize": 1000000,
    "stateId": 0,
    "districtId": 0,
    "pinCode": 0,
  });
  const dispatch = useDispatch();
  let location = useLocation();
  const navigation = useNavigate();
  const { t, i18n } = useTranslation();
  const handleNavigate = () => {
    navigation(ROUTES.LOGINFORKENDRA);
  };
  const getKendraCount = async () => {
    try {
      const response = await getKendraVisiterCount();
      if (response?.data?.responseCode == 200) {
        dispatch(setVisitedUserReducer(response?.data?.VisitedUserCount));
      } else {
        toastEmitter(
          "error",
          response?.data?.message || API_RESPONSE.MESSAGE_500
        );
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE.MESSAGE_503);
    }
  };

  const getAllKendraListCount = async () => {
    try {
      const response = await getAllKendraCount();
      if (response?.status == 200) {
        setKendraCount(response?.data?.data);
      } else {
        toastEmitter("error", response?.data?.message);
      }
    } catch (err) {
    }
  }

  useEffect(() => {
    getKendraCount();
    getAllKendraListCount()
  }, []);

  useEffect(() => {
    const savedLanguage = localStorage.getItem("language") || "en";
    setLanguage(savedLanguage);
    i18n.changeLanguage(savedLanguage);
  }, [i18n]);

  const changeLanguage = (lng) => {
    setLanguage(lng);
    localStorage.setItem("language", lng);
    i18next.changeLanguage(lng);
  };
  const scrollToBottom = () => {
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    // Step 1: Store the original font sizes when the component mounts
    const elements = [
      "a",
      "p",
      "h1",
      "h2",
      "h3",
      "h4",
      "h5",
      ".topbar-left-content",
      ".nav-link",
      ".card-text",
      ".dropdown-item",
      ".footer-text",
      ".labelText",
    ];
    elements.forEach((selector) => {
      document.querySelectorAll(selector).forEach((element) => {
        if (!element.dataset.originalFontSize) {
          element.dataset.originalFontSize = window
            .getComputedStyle(element)
            .getPropertyValue("font-size");
        }
      });
    });
  }, []);

  const handleFontSizemax = (size) => {
    setIncCount((prevCount) => {
      if (prevCount < 5) {
        setdisbtn(false);
        adjustFontSize(1);
        return prevCount + 1;
      }
      return prevCount;
    });
  };

  const handleFontSizemin = (size) => {
    setDisCount((prevCount) => {
      adjustFontSize(-1);
      return prevCount + 1;
    });
    setIncCount(0);
  };

  const adjustFontSize = (adjustment) => {
    const elements = [
      "a",
      "p",
      "h1",
      "h2",
      "h3",
      "h4",
      "h5",
      ".topbar-left-content",
      ".nav-link",
      ".card-text",
      ".dropdown-item",
      ".footer-text",
      ".labelText",
    ];
    elements.forEach((selector) => {
      document.querySelectorAll(selector).forEach((element) => {
        const currentSize = parseFloat(
          window.getComputedStyle(element).getPropertyValue("font-size")
        );
        const newSize = currentSize + adjustment + "px";
        element.style.fontSize = newSize;
      });
    });
  };

  // Step 2: Create a function to reset the font sizes
  const handleFontSizeReset = () => {
    const elements = [
      "a",
      "p",
      "h1",
      "h2",
      "h3",
      "h4",
      "h5",
      ".topbar-left-content",
      ".nav-link",
      ".card-text",
      ".dropdown-item",
      ".footer-text",
      ".labelText",
    ];
    elements.forEach((selector) => {
      document.querySelectorAll(selector).forEach((element) => {
        element.style.fontSize = element.dataset.originalFontSize;
      });
    });
    setIncCount(0);
    setDisCount(0);
    setdisbtn(true);
  };

  const handleAccesabilityDiv = () => {
    setIIsAccessabilityDiv(!isAccessabilityDiv);
  };

  const applyColors = (bgColor, color) => {
    const element = document.querySelectorAll("#spanColor");
    element.forEach((element) => {
      element.style.color = color;
    });
    const element2 = document.querySelectorAll("#headingColor");
    element2.forEach((element) => {
      element.style.color = color;
    });

    const setColorForClass = (className) => {
      const elements = document.getElementsByClassName(className);
      for (const element of elements) {
        element.style.background = bgColor;
      }
    };

    setColorForClass("ja-primary-bg");
    setColorForClass("nav-bg");
    setColorForClass("footer-bg");
    setColorForClass("dropdown-menu");
    setColorForClass("home-bg");
    setColorForClass("jana_news_sec");
    setColorForClass("jana_video_innersection");
    setColorForClass("jana_successtory_section");
    setColorForClass("jana_gallery_innersection");
  };

  const handleColorChange = (newBgColor, newColor) => {
    setBgColor(newBgColor);
    setColor(newColor);
    localStorage.setItem("bgColor", newBgColor);
    localStorage.setItem("color", newColor);
    applyColors(newBgColor, newColor);
  };

  useEffect(() => {
    const storedBgColor = localStorage.getItem("bgColor") || "";
    const storedColor = localStorage.getItem("color") || "";
    setBgColor(storedBgColor);
    setColor(storedColor);
    applyColors(storedBgColor, storedColor);
  }, [location]);

  //Clear Color of Accessablity
  const clearColorChanges = () => {
    localStorage.removeItem("bgColor");
    localStorage.removeItem("color");

    const elements = document.querySelectorAll("#spanColor");
    elements.forEach((element) => {
      element.style.color = "";
    });
    const element2 = document.querySelectorAll("#headingColor");
    element2.forEach((element) => {
      element.style.color = "";
    });

    const clearColorForClass = (className) => {
      const elements = document.getElementsByClassName(className);
      for (let i = 0; i < elements.length; i++) {
        elements[i].style.background = "";
      }
    };

    clearColorForClass("ja-primary-bg");
    clearColorForClass("nav-bg");
    clearColorForClass("footer-bg");
    clearColorForClass("dropdown-menu");
    clearColorForClass("home-bg");
    clearColorForClass("jana_news_sec");
    clearColorForClass("jana_video_innersection");
    clearColorForClass("jana_successtory_section");
    clearColorForClass("jana_gallery_innersection");
  };

  const handleAdminLogin = () => {
    dispatch(clearAccessTokenReducer())
    dispatch(clearLoggedUserReducer())
    localStorage.removeItem("mMenuData")
    navigation(process.env.PUBLIC_URL + "/admin/login")
  }

  // redirect on old application recruitment page
  const navigateRecruitment = () => {
    const newUrl = 'https://recruitment.pmbi.co.in/';
    window.open(newUrl, '_blank');
  }
  const navigateEventMaterial = () => {
    const newUrl = 'https://drive.google.com/drive/folders/1r4mtC_iLbtQD858sj_LwSMEDeb_Z32bN?usp=drive_link';
    window.open(newUrl, '_blank');
  }
  const navigatejanaushadhiMitra = () => {
    const newUrl = 'https://volunteer.pmbi.co.in/';
    window.open(newUrl, '_blank');
  }

  /// Toggle child dropdown visibility for sugam app
  const handleParentClick = (event) => {
    event.stopPropagation();
    setChildDropdownOpen((prev) => !prev);
  };

  const handleChildItemClick = (url) => {
    window.open(url, "_blank");
    setChildDropdownOpen(false); // Close the child dropdown
  };

  return (
    <>
      {/* -----first header section --- */}
      <div className="header ">
        <div className="top-bar-sec ja-primary-bg px-3">
          <div className="container-fluid">
            <div className="row py-1">
              <div className="col-sm-12 col-md-12 col-lg-6 d-flex align-items-center">
                <div className="topbar-left mb-sm-3 mb-md-3 mb-lg-0 mt-sm-2 mt-md-2 mt-lg-0 d-flex flex-wrap justify-content-sm-center justify-content-md-center justify-content-lg-start align-items-center">
                  {/* <div className="topbar-left-content me-md-4 mb-md-0 sepraterborder">
                    <span className="mb-0 me-3" id="spanColor">
                      {t("totalkendra")} : {kendraCount ? kendraCount : 0}
                    </span>
                  </div> */}
                  <div className="topbar-left-content me-md-4 mb-md-0 sepraterborder">
                    <a href="tel:18001808080">
                      <span className="mb-0 me-3" id="spanColor">
                        {t("tolfree")}-1800-180-8080
                      </span>
                    </a>
                  </div>
                  <div className="topbar-left-content">
                    <a href="mailto:complaints@janaushadhi.gov.in">
                      <span className="mb-0" id="spanColor">
                        complaints[at]janaushadhi[dot]gov[dot]in
                      </span>
                    </a>

                  </div>
                </div>
              </div>
              <div className="col-sm-12 col-md-12 col-lg-6">
                <div className="topbar-right d-flex flex-wrap justify-content-sm-center justify-content-md-center justify-content-lg-end align-items-center">
                  <div
                    className="text-white me-3 sepraterborder header_icon"
                    onClick={scrollToBottom}
                  >
                    <Tooltip title="Top To Bottom" arrow>
                      <img
                        src={ICON_IMG}
                        alt=""
                        className="headericon rounded-3 me-sm-3 me-md-3 me-lg-3 cursor-pointer"
                      />
                    </Tooltip>

                  </div>
                  <div
                    className="text-white me-3 sepraterborder header_icon"
                    onClick={handleAccesabilityDiv}
                  >
                    <Tooltip title="Accesability" arrow>

                      <img
                        src={DISABILIT_ICON}
                        alt=""
                        className="headericon rounded-3 me-sm-3 me-md-3 me-lg-3 cursor-pointer"
                      />
                    </Tooltip>


                    {isAccessabilityDiv && (
                      <div className="accessabiity-dropdown px-2">
                        <h6
                          className="text-center mt-2 mb-0 cursor-pointer"
                          onClick={() => handleFontSizemax(0)}
                        >
                          A+
                        </h6>
                        <hr className="m-2"></hr>
                        <h6
                          className="text-center mt-2 mb-0 cursor-pointer"
                          onClick={handleFontSizeReset}
                        >
                          A
                        </h6>
                        <hr className="m-2"></hr>
                        <h6
                          className="text-center mt-2 mb-0 cursor-pointer"
                          onClick={() => handleFontSizemin(6)}
                        >
                          A-
                        </h6>
                        <hr className="m-2"></hr>
                        <h6
                          className="text-center mt-2 mb-0 black-text cursor-pointer"
                          id="spanColor"
                          onClick={() => handleColorChange("#000", " #ffff00")}
                        >
                          A
                        </h6>
                        <hr className="m-2"></hr>
                        <h6
                          className="text-center mt-2 mb-0 white-text cursor-pointer"
                          id="spanColor"
                          onClick={clearColorChanges}
                        >
                          A
                        </h6>
                      </div>
                    )}
                  </div>

                  <div className="text-white me-3 sepraterborder header_icon">
                    <Link to={ROUTES.SITEMAP} className="">
                      <Tooltip title="SiteMap" arrow>
                        <img
                          src={USERICON_IMG}
                          alt=""
                          className="headericon rounded-3 me-sm-3 me-md-3 me-lg-3"
                        />
                      </Tooltip>

                    </Link>
                  </div>
                  <div className="text-white me-3 sepraterborder header_icon">
                    <Link to={ROUTES.SCREENRECORDER} className="">
                      <Tooltip title="Screen Reader" arrow>
                        <img
                          src={PROFILEICON_IMG}
                          alt=""
                          className="headericon rounded-3 me-sm-3 me-md-3 me-lg-3 text-dark"
                        />
                      </Tooltip>
                    </Link>
                  </div>
                  <div className="bhashini-app-width">

                  </div>
                  {/* <select
                    class="lang-tab text-white langbutton-bg rounded-2 p-1 me-3"
                    value={language}
                    onChange={(e) => changeLanguage(e.target.value)}
                  >
                    <option value="en"> {t("english")}</option>
                    <option value="hi"> {t("hindi")}</option>
                  </select> */}

                  <button className="lang-tab deptlogin text-white langbutton-bg rounded-2 px-3 py-1 dept-btn " onClick={handleAdminLogin}>login</button>

                </div>
                <div className="bhashini-app-width-reponsive">
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* -----second header section --- */}
        <div className="products-logo-sec mb-3 mt-3 mb-0 px-3">
          <div className="container-fluid">
            <div className="row g-0 text-center">
              <div className="col-sm-12 col-md-6 col-lg-6">
                <div className="row g-0">
                  <div className="col-5 d-flex justify-content-center ">
                    <img
                      src={GOVT_IMG_1}
                      alt=""
                      className="img-fluid secondtop header-img-fit"
                      width={"100%"}
                    />
                  </div>
                  <div className="col-3  d-flex justify-content-center">
                    <img
                      src={AAJADI_IMG_1}
                      alt=""
                      className="img-fluid d-flex justify-content-center justify-content-lg-start header-img-fit"
                      width={"100%"}
                    />
                  </div>
                  <div className="col-3 d-flex justify-content-center justify-content-lg-start">
                    <img
                      src={SWACHH_BHARAT_IMG}
                      alt=""
                      className="img-fluid header-img-fit"
                      width={"100%"}
                    />
                  </div>
                </div>
              </div>

              <div className="col-sm-12 col-md-6 col-lg-6 d-flex align-items-center justify-content-lg-end">
                <div className="row g-0">
                  <div className="col-4 d-flex justify-content-center justify-content-lg-end align-items-center">
                    <img
                      src={PRIYOJNA_IMG_1}
                      alt=""
                      className="img-fluid px-0 px-lg-3 header-img-fit"
                      width={"100%"}
                    />
                  </div>
                  <div className="col-8 d-flex justify-content-center justify-content-lg-end align-items-center">
                    <img
                      src={PMBI_IMAGE_1}
                      alt=""
                      className="img-fluid header-img-fit"
                      width={"100%"}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* -----third header section --- */}
        <div className="jana_nav_sec nav-bg px-3">
          <div className="jana-inner-sec">
            <div className="container-fluid">
              <nav className="navbar navbar-expand-lg navbar-light p-0 mt-3">
                <div className="container-fluid px-0 ">
                  <div className="d-flex justify-content-between align-item-center menucontent">
                    <button
                      className="navbar-toggler my-2"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#navbarSupportedContent"
                      aria-controls="navbarSupportedContent"
                      aria-expanded="false"
                      aria-label="Toggle navigation"
                    >
                      <span className="navbar-toggler-icon"></span>
                    </button>

                    <div className="d-flex d-lg-none py-1 ">
                      {location.pathname ===
                        "/janaushadhi/kendra-registration" ||
                        location.pathname === "/janaushadhi/apply-for-kendra" ||
                        location.pathname ===
                        "/janaushadhi/kendra-registration" ||
                        location.pathname === "/janaushadhi/forgot-password" ||
                        location.pathname === "/janaushadhi/reset-password" ||
                        location.pathname === "/janaushadhi/login-to-kendra" ? (
                        ""
                      ) : (
                        <>

                          <Button
                            buttonName={t("ApplyForKendra")}
                            buttonStyle={
                              "border-0 button-bg rounded-3 text-white px-4 p-2 applyforkendrabtn"
                            }
                            handleClick={handleNavigate}
                          />
                        </>
                      )}
                      {isSearch ? (
                        <GlobalSearch setIsSerach={setIsSerach} />
                      ) : (
                        <button
                          className="btn text-white button-bg ms-2 p-0 px-2"
                          type="button"
                          onClick={() => setIsSerach(true)}
                        >
                          <img
                            src={SEARCHICON_IMG}
                            alt="search"
                            className="img-fluid serchicon"
                          />
                        </button>
                      )}
                    </div>

                  </div>
                  
                  {/* <div className="d-lg-none d-flex justify-content-end align-items-center menucontent">
                    <Button
                      buttonName="Janaushadhi Mitra"
                      buttonStyle={
                        "border-0 button-bg rounded-3 p-2 text-white blink_button mx-0 my-2 responsive-janaushadhi-btn"
                      }
                      handleClick={navigatejanaushadhiMitra}
                    />
                  </div> */}
                  <div
                    className="collapse navbar-collapse justify-content-between"
                    id="navbarSupportedContent"
                  >
                    <ul className="navbar-nav">
                      <li className="nav-item ">
                        <Link
                          className="nav-link text-white ps-0"
                          to={ROUTES.HOME}
                        >
                          <img
                            src={HOMEICON_IMG}
                            alt=""
                            width="30"
                            height="30"
                          />
                        </Link>
                      </li>
                      <li className="nav-item dropdown ms-2">
                        <span
                          id="spanColor"
                          className="nav-link dropdown-toggle"
                          href="#"
                          role="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          {t("Message")}
                        </span>
                        <ul className="dropdown-menu">
                          <li>
                            <span
                              id="spanColor"
                              className="dropdown-item cursor-pointer"
                              onClick={() =>
                                navigation(
                                  `${process.env.PUBLIC_URL
                                  }/message-page/${"chairperson"}`
                                )
                              }
                            >
                              {t("ChairpersonsDesk")}
                            </span>
                          </li>
                          <li>
                            <hr className="dropdown-divider" />
                          </li>
                          <li>
                            <span
                              className="dropdown-item cursor-pointer"
                              id="spanColor"
                              onClick={() =>
                                navigation(
                                  `${process.env.PUBLIC_URL
                                  }/message-page/${"ceodesk"}`
                                )
                              }
                            >
                              {t("CEOsDesk")}
                            </span>
                          </li>
                        </ul>
                      </li>

                      <li className="nav-item dropdown ms-2">
                        <span
                          className="nav-link dropdown-toggle"
                          href="#"
                          role="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          id="spanColor"
                        >
                          {t("Governance")}
                        </span>
                        <ul className="dropdown-menu">
                          <li>
                            <span
                              className="dropdown-item cursor-pointer"
                              id="spanColor"
                              onClick={() => navigation(ROUTES.GOVERNANCE)}
                            >
                              {t("GoverningCouncil")}
                            </span>
                          </li>
                          <li>
                            <hr className="dropdown-divider" />
                          </li>
                          <li>
                            <span
                              className="dropdown-item cursor-pointer"
                              id="spanColor"
                              onClick={() => navigation(ROUTES.EXECUTIVE)}
                            >
                              {t("ExecutiveCouncil")}
                            </span>
                          </li>
                          <li>
                            <hr className="dropdown-divider" />
                          </li>
                          <li>
                            <span
                              className="dropdown-item cursor-pointer"
                              onClick={() => navigation(ROUTES.ORGANIZATION)}
                              id="spanColor"
                            >
                              {t("OrganizationChart")}
                            </span>
                          </li>
                          <li>
                            <hr className="dropdown-divider" />
                          </li>
                          <li>
                            <span
                              className="dropdown-item cursor-pointer"
                              id="spanColor"
                              onClick={() => navigation(ROUTES.MANAGEMENT)}
                            >
                              {t("ManagementTeam")}
                            </span>
                          </li>
                        </ul>
                      </li>
                      <li class="nav-item dropdown ms-2">
                        <span
                          className="nav-link dropdown-toggle"
                          href="#"
                          role="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          id="spanColor"
                        >
                          {t("PMBJP")}
                        </span>
                        <ul className="dropdown-menu">
                          <li>
                            <span
                              className="dropdown-item cursor-pointer"
                              id="spanColor"
                              onClick={() => navigation(ROUTES.PMBJBSCHEME)}
                            >
                              {" "}
                              {t("PMBJPScheme")}
                            </span>
                          </li>
                          <li>
                            <hr className="dropdown-divider" />
                          </li>
                          <li>
                            <span
                              className="dropdown-item cursor-pointer"
                              onClick={() =>
                                navigation(ROUTES.LOCATEKENDRA)
                              }
                              id="spanColor"
                            >
                              {t("LocatePMBJPKendra")}
                            </span>
                          </li>
                          <li>
                            <hr className="dropdown-divider" />
                          </li>
                          <li>
                            <span
                              className="dropdown-item cursor-pointer"
                              onClick={() =>
                                navigation(ROUTES.LOCATEDISTRIBUTOR)
                              }
                              id="spanColor"
                            >
                              {t("LocateDistributor")}
                            </span>
                          </li>
                          <li>
                            <hr className="dropdown-divider" />
                          </li>
                          <li>
                            <span
                              className="dropdown-item cursor-pointer"
                              onClick={() => navigation(ROUTES.PMHOSPITAL)}
                              // to={ROUTES.PMHOSPITAL}
                              id="spanColor"
                            >
                              {t("ABPMJAYHospital")}
                            </span>
                          </li>
                          <li>
                            <hr className="dropdown-divider" />
                          </li>
                          <li>
                            <span
                              className="dropdown-item cursor-pointer"
                              onClick={() => navigation(ROUTES.ANNUALREPORT)}
                              id="spanColor"
                            >
                              {" "}
                              {t("AnnualReport")}
                            </span>
                          </li>
                          <li>
                            <hr className="dropdown-divider" />
                          </li>
                          <li>
                            <span
                              className="dropdown-item cursor-pointer"
                              onClick={() => navigation(ROUTES.FINANCEREPORT)}
                              id="spanColor"
                            >
                              {" "}
                              {t("FinancialReport")}
                            </span>
                          </li>
                          <li>
                            <hr className="dropdown-divider" />
                          </li>
                          <li>
                            <span
                              className="dropdown-item cursor-pointer"
                              onClick={() => navigation(ROUTES.FAQ)}
                              id="spanColor"
                            >
                              {" "}
                              {t("FAQs")}
                            </span>
                          </li>
                        </ul>
                      </li>
                      <li className="nav-item dropdown ms-2">
                        <span
                          className="nav-link dropdown-toggle"
                          href="#"
                          role="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          id="spanColor"
                        >
                          {t("productportfolio")}
                        </span>
                        <ul className="dropdown-menu">
                          <li>
                            <span
                              className="dropdown-item cursor-pointer"
                              id="spanColor"
                              onClick={() =>
                                navigation(
                                  `${process.env.PUBLIC_URL
                                  }/productportfolio/${"ProductmrpList"}`
                                )
                              }
                            >
                              {t("productmrplist")}
                            </span>
                          </li>
                          <li>
                            <hr className="dropdown-divider" />
                          </li>
                          <li>
                            <span
                              className="dropdown-item cursor-pointer"
                              id="spanColor"
                              onClick={() =>
                                navigation(
                                  `${process.env.PUBLIC_URL
                                  }/productportfolio/${"ProductviewList"}`
                                )
                              }
                            >
                              {t("productviewlist")}
                            </span>
                          </li>
                        </ul>
                      </li>
                      <li className="nav-item dropdown ms-2">
                        <span
                          className="nav-link dropdown-toggle"
                          href="#"
                          role="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          id="spanColor"
                        >
                          {t("Tenders")}
                        </span>
                        <ul className="dropdown-menu">
                          <li>
                            <span
                              className="dropdown-item cursor-pointer"
                              // to={ROUTES.TENDER}
                              id="spanColor"
                              onClick={() => navigation(ROUTES.TENDER)}
                            >
                              {t("TenderDetails")}
                            </span>
                          </li>
                          <li>
                            <hr className="dropdown-divider" />
                          </li>
                          <li>
                            <span
                              className="dropdown-item cursor-pointer"
                              // to={ROUTES.DEBBAREDLIST}
                              id="spanColor"
                              onClick={() => navigation(ROUTES.DEBBAREDLIST)}
                            >
                              {t("DebarredList")}
                            </span>
                          </li>
                          <li>
                            <hr className="dropdown-divider" />
                          </li>
                          <li>
                            <span
                              className="dropdown-item cursor-pointer"
                              // to={ROUTES.BLACKLIST}
                              id="spanColor"
                              onClick={() => navigation(ROUTES.BLACKLIST)}
                            >
                              {t("BlackList")}
                            </span>
                          </li>
                          <li>
                            <hr className="dropdown-divider" />
                          </li>
                          <li>
                            <span
                              className="dropdown-item cursor-pointer"
                              id="spanColor"
                              onClick={() => navigation(ROUTES.AWARDEDLIST)}
                            >
                              {t("AwardedTender")}
                            </span>
                          </li>
                          <li>
                            <hr className="dropdown-divider" />
                          </li>
                          <li>
                            <span
                              className="dropdown-item cursor-pointer"
                              // to={ROUTES.REVOCATIONORDER}
                              id="spanColor"
                              onClick={() => navigation(ROUTES.REVOCATIONORDER)}
                            >
                              {t("RevocationOrder")}
                            </span>
                          </li>
                        </ul>
                      </li>
                      <li className="nav-item dropdown ms-2">
                        <span
                          className="nav-link dropdown-toggle "
                          href="#"
                          role="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          id="spanColor"
                        >
                          {t("Support")}
                        </span>
                        <ul className="dropdown-menu">
                          <li>
                            <span
                              className="dropdown-item cursor-pointer"
                              id="spanColor"
                              onClick={() => navigation(ROUTES.PACSTRAINING)}
                            >
                              {t("PACSTraining")}
                            </span>
                          </li>
                          <li>
                            <hr className="dropdown-divider" />
                          </li>
                          <li>
                            <span
                              className="dropdown-item cursor-pointer"
                              // to={ROUTES.POSTRAINING}
                              id="spanColor"
                              onClick={() => navigation(ROUTES.POSTRAINING)}
                            >
                              {t("POSTraining")}
                            </span>
                          </li>
                          <li>
                            <hr className="dropdown-divider" />
                          </li>
                          <li>
                            <span
                              className="dropdown-item cursor-pointer"
                              // to={ROUTES.DOWNLOADLINK}
                              id="spanColor"
                              onClick={() => navigation(ROUTES.DOWNLOADLINK)}
                            >
                              {t("DownloadTrainingLink")}
                            </span>
                          </li>
                          <li>
                            <hr className="dropdown-divider" />
                          </li>
                          <li>
                            <span
                              className="dropdown-item cursor-pointer"
                              onClick={() =>
                                navigation(ROUTES.SOFTWAREHELPLINE)
                              }
                              // to={ROUTES.SOFTWAREHELPLINE}
                              id="spanColor"
                            >
                              {t("RetailSoftwareHelpline")}
                            </span>
                          </li>
                          <li>
                            <hr className="dropdown-divider" />
                          </li>
                          <li>
                            <span
                              className="dropdown-item cursor-pointer position-relative download-sugam-app dropdown-toggle"
                              onClick={handleParentClick}
                              id="spanColor"
                              aria-expanded={isChildDropdownOpen}
                            >
                              {t("SugamAppDownload")}
                            </span>
                            {isChildDropdownOpen && (
                              <div className="position-absolute child-dropdown-position">
                                <ul className="child-dropdown">
                                  <li>
                                    <span
                                      className="dropdown-item cursor-pointer"
                                      onClick={() =>
                                        handleChildItemClick(
                                          "https://apps.apple.com/in/app/jan-aushadhi-sugam-pmbi/id1476574620"
                                        )
                                      }
                                    >
                                      {t("iOSApp")}
                                    </span>
                                  </li>
                                  <li>
                                    <hr className="dropdown-divider" />
                                  </li>
                                  <li>
                                    <span
                                      className="dropdown-item cursor-pointer"
                                      onClick={() =>
                                        handleChildItemClick(
                                          "https://play.google.com/store/apps/details?id=in.gov.pmbjp&hl=en_IN"
                                        )
                                      }
                                    >
                                      {t("AndroidApp")}
                                    </span>
                                  </li>
                                </ul>
                              </div>
                            )}
                          </li>
                          <li>
                            <hr className="dropdown-divider" />
                          </li>
                          <li>
                            <span
                              className="dropdown-item cursor-pointer"
                              onClick={() => navigation(ROUTES.SUGAMHELPLINE)}
                              // to={ROUTES.SUGAMHELPLINE}
                              id="spanColor"
                            >
                              {t("SugamAppHelpline")}
                            </span>
                          </li>
                          <li>
                            <hr className="dropdown-divider" />
                          </li>
                          <li>
                            <span
                              className="dropdown-item cursor-pointer"
                              // to={ROUTES.KENDRACOMPLAINTS}
                              onClick={() =>
                                navigation(ROUTES.KENDRACOMPLAINTS)
                              }
                              id="spanColor"
                            >
                              {t("KendraComplaints")}
                            </span>
                          </li>
                          <li>
                            <hr className="dropdown-divider" />
                          </li>
                          <li>
                            <span
                              className="dropdown-item cursor-pointer"
                              onClick={() => navigation(ROUTES.VENDORPORTAL)}
                              // to={ROUTES.VENDORPORTAL}
                              id="spanColor"
                            >
                              {t("VendorLabPortal")}
                            </span>
                          </li>
                          {/* <li>
                            <hr className="dropdown-divider" />
                          </li>
                          <li>
                            <span
                              className="dropdown-item cursor-pointer"
                              onClick={() => navigation(ROUTES.WEBINARTUTORIAL)}
                              // to={ROUTES.WEBINARTUTORIAL}
                              id="spanColor"
                            >
                              {t("WebinarTutorials")}
                            </span>
                          </li> */}
                        </ul>
                      </li>

                      <li className="nav-item dropdown ms-2">
                        <span
                          className="nav-link dropdown-toggle"
                          href="#"
                          role="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          id="spanColor"
                        >
                          {t("Media")}
                        </span>
                        <ul className="dropdown-menu">
                          <li>
                            <span
                              className="dropdown-item cursor-pointer"
                              onClick={() => navigation(ROUTES.MEDIA)}
                              // to={ROUTES.MEDIA}
                              id="spanColor"
                            >
                              {t("EventCalendar")}
                            </span>
                          </li>
                          <li>
                            <span
                              className="dropdown-item cursor-pointer"
                              onClick={() => navigation(ROUTES.MAINGALLERY)}
                              // to={ROUTES.MEDIA}
                              id="spanColor"
                            >
                              {t("gallery")}
                            </span>
                          </li>
                          <li>
                            <span
                              className="dropdown-item cursor-pointer"
                              onClick={navigateEventMaterial}
                              id="spanColor"
                            >
                              {t("eventMaterial")}
                            </span>
                          </li>
                        </ul>
                      </li>
                      <li className="nav-item ms-2">
                        <span
                          className="footer-text cursor-pointer ps-0"
                          onClick={() => navigation(ROUTES.CONTACTUS)}
                          // to={ROUTES.CONTACTUS}
                          id="spanColor"
                        >
                          {t("ContactUs")}
                        </span>
                      </li>

                      <li className="nav-item ms-2">
                        <span
                          className="footer-text cursor-pointer ps-0"
                          onClick={navigateRecruitment}
                          id="spanColor"
                        >
                          {t("Recruitment_header")}
                        </span>
                      </li>

                      {/* View only laptop and desktop view */}
                      {/* <li className="d-none d-lg-block">
                        <Button
                          buttonName="Janaushadhi Mitra"
                          buttonStyle={
                            "border-0 button-bg rounded-3 p-2 text-white blink_button"
                          }
                          handleClick={navigatejanaushadhiMitra}
                        />
                      </li> */}
                    </ul>
                    <div className="d-lg-flex  d-none py-1 ">

                      {location.pathname ===
                        "/janaushadhi/kendra-registration" ||
                        location.pathname === "/janaushadhi/apply-for-kendra" ||
                        location.pathname ===
                        "/janaushadhi/kendra-registration" ||
                        location.pathname === "/janaushadhi/forgot-password" ||
                        location.pathname === "/janaushadhi/reset-password" ||
                        location.pathname === "/janaushadhi/login-to-kendra" ? (
                        ""
                      ) : (

                        <Button
                          buttonName={t("ApplyForKendra")}
                          buttonStyle={
                            "border-0 button-bg rounded-3 px-4 p-2 text-white"
                          }
                          handleClick={handleNavigate}
                        />

                      )}
                      {isSearch ? (
                        <GlobalSearch setIsSerach={setIsSerach} />
                      ) : (
                        <button
                          className="btn button-bg ms-2 p-0 px-2"
                          type="button"
                          onClick={() => setIsSerach(true)}
                        >
                          <img
                            src={SEARCHICON_IMG}
                            alt="search"
                            className="img-fluid serchicon"
                          />
                        </button>
                      )}
                    </div>


                  </div>
                </div>
              </nav>
            </div>
          </div >
          {/* <marquee  direction="left" >
          Important Note: Dear Applicant, If you have already applied through our old application portal, please be assured that your application is being processed. There is no need to re-apply.</marquee> */}
        </div >
      </div >
      {/* -----Banner image --- */}
      {/* <div>
        <img src={crouselimg} class="d-block w-100" alt="..." />
      </div> */}
      <SocialPage />
      {/* -----fourth heading line --- */}
    </>
  );
};

export default Header;
